import * as actionTypes from 'actions';

const initialState = {
  page: 1,
};

const companyServiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PAGINATION_COMPANY_SERVICE: {
      return { ...action.payload };
    }

    case actionTypes.CLEAR_PAGINATION_COMPANY_SERVICE: {
      return { ...initialState };
    }

    default:
      return state;
  }
};

export default companyServiceReducer;
